import { useCallback, useEffect } from 'react';
import { EKeyboardKey } from '../types/EKeyboardKey';
export const useSuggestKeyboard = _ref => {
  let {
    onEnter,
    onEscape,
    onKeyboardSetItem,
    suggestionsChildrenRef,
    listBoxRef
  } = _ref;
  const handleChildrenElementKeyDown = useCallback(e => {
    switch (e.key) {
      case EKeyboardKey.ArrowUp:
        onKeyboardSetItem('decrement');
        break;
      case EKeyboardKey.ArrowDown:
        onKeyboardSetItem('increment');
        break;
      case EKeyboardKey.Home:
      case EKeyboardKey.PageUp:
        onKeyboardSetItem('first');
        break;
      case EKeyboardKey.End:
      case EKeyboardKey.PageDown:
        onKeyboardSetItem('last');
        break;
      case EKeyboardKey.Escape:
        onEscape === null || onEscape === void 0 || onEscape();
        break;
      case EKeyboardKey.Enter:
        onEnter();
        break;
    }
  }, [onEscape, onEnter, onKeyboardSetItem]);
  useEffect(() => {
    if (!suggestionsChildrenRef.current || !listBoxRef.current) {
      return;
    }
    const currentSuggestionsChildrenRef = suggestionsChildrenRef.current;
    const currentListBoxRef = listBoxRef.current;
    currentSuggestionsChildrenRef.addEventListener('keydown', handleChildrenElementKeyDown);
    currentListBoxRef.addEventListener('keydown', handleChildrenElementKeyDown);
    return () => {
      currentSuggestionsChildrenRef.removeEventListener('keydown', handleChildrenElementKeyDown);
      currentListBoxRef.removeEventListener('keydown', handleChildrenElementKeyDown);
    };
  }, [handleChildrenElementKeyDown, suggestionsChildrenRef, listBoxRef]);
};